export default {
    LauncherDownloadHost: {
        dev: 'http://dev-download.d.nexon.io/download-launcher',
        testPre: 'https://test-download.nxfs.nexon.com/download-launcher',
        test: 'https://test-download.nxfs.nexon.com/download-launcher',
        pre: 'https://pre-download.nxfs.nexon.com/download-launcher',
        prod: 'https://download.nxfs.nexon.com/download-launcher',
    },
};
